import { defineUi } from '@dashboard/module-contract/ui';
import type { SesRole } from '../manifest';

export const ui = defineUi<SesRole>({
	routes: [
		{
			path: '',
			title: 'Domains',
			requiredRole: 'ses:reader',
			component: () => import('./views/domains.vue'),
		},
		{
			path: 'activity',
			title: 'Delivery activity',
			// Reading what bounced is reading, and the page writes nothing.
			requiredRole: 'ses:reader',
			component: () => import('./views/activity.vue'),
		},
		{
			path: 'blocked',
			title: 'Blocked addresses',
			// Seeing who cannot be mailed is reading. Blocking and unblocking
			// are `ses:operator`, enforced by the API.
			requiredRole: 'ses:reader',
			component: () => import('./views/suppression.vue'),
		},
		{
			path: 'credentials',
			title: 'SMTP credentials',
			// Reader, not admin: knowing what exists and what it can send as
			// is exactly what auditing your own account needs. Creating and
			// revoking are `ses:admin`, enforced by the API.
			requiredRole: 'ses:reader',
			component: () => import('./views/credentials.vue'),
		},
		/**
		 * One sending domain, with no nav entry — reached from the list and by
		 * its URL.
		 *
		 * **`domains/:domain`, not a bare `:domain`** (`D171`). This module
		 * has four single-segment routes, and sites — with one — still needed
		 * a comment warning that relying on vue-router ranking a static above
		 * a parameter is silent when it goes wrong. Four is too many to leave
		 * to ranking.
		 */
		{
			path: 'domains/:domain',
			title: 'Domain',
			requiredRole: 'ses:reader',
			component: () => import('./views/domain-overview.vue'),
		},
		{
			path: 'domains/:domain/health',
			title: 'Domain health',
			// A read, and the person fielding "our mail is bouncing" is not
			// necessarily the person who may add or remove a domain.
			requiredRole: 'ses:reader',
			component: () => import('./views/domain-health.vue'),
		},
		{
			path: 'domains/:domain/activity',
			title: 'Domain delivery activity',
			// A reader's, like the account feed it moved off: knowing what is
			// bouncing is what auditing your own account looks like.
			requiredRole: 'ses:reader',
			component: () => import('./views/domain-activity.vue'),
		},
		{
			path: 'domains/:domain/settings',
			title: 'Domain settings',
			// Reader, like the overview: the page shows what is true and the
			// switches are hidden without `ses:operator`, which the API
			// enforces either way.
			requiredRole: 'ses:reader',
			component: () => import('./views/domain-settings.vue'),
		},
		{
			// The module's own page, at the path every module's settings use
			// (`D109`), rather than a fragment the core's admin page hosts.
			path: 'settings',
			title: 'Settings',
			requiredRole: 'ses:admin',
			component: () => import('./views/settings.vue'),
		},
	],
});
